import styled from "@emotion/styled";
import theme from "../../theme";
import { EventType } from "../../types/types";
import { EventTag } from "../../components/EventTag";
import { useWindowSize } from "@reactuses/core";
import { useI18n } from "../../locales";

const { sm } = theme.screen;

type Prop = {
  events: EventType[] | null;
};

export const DeviceState = ({ events }: Prop) => {
  const { width: windowWidth } = useWindowSize();
  const { t } = useI18n();

  // 전달받은 이벤트가 존재하는지 체크하는 함수
  const eventChecker = (e: EventType) => {
    let result = false;
    if (!events) return;
    events.map((el) => {
      if (el.includes(e)) {
        result = true;
      }
    });

    return result;
  };

  // console.log(events);

  return (
    <>
      <StatusWrapper>
        <ThinText>{t.control.currentStatus}</ThinText>
        <EventTag
          text={t.control.statusNormal}
          color={events === null ? "green" : "grey"}
          withoutMl
          width={windowWidth <= theme.screen.sm ? "auto" : "60px"}
        />

        <EventTag
          text={t.control.statusCaution}
          color={
            events && events.length > 0 && !eventChecker("차량전복")
              ? "yellow"
              : "grey"
          }
          withoutMl
          width={windowWidth <= theme.screen.sm ? "auto" : "60px"}
        />

        <EventTag
          text={t.control.statusDanger}
          color={eventChecker("차량전복") ? "red" : "grey"}
          withoutMl
          width={windowWidth <= theme.screen.sm ? "auto" : "60px"}
        />
      </StatusWrapper>
      <StatusWrapper>
        <ThinText>{t.control.accidentOccurred}</ThinText>
        <Chips>
          <EventTag
            text={t.control.vehicleRollover}
            color={eventChecker("차량전복") ? "red" : "grey"}
            withoutMl
            width={windowWidth <= theme.screen.sm ? "65px" : "auto"}
          />
          <EventTag
            text={t.control.dangerousDriving}
            color={eventChecker("위험운전") ? "orange" : "grey"}
            withoutMl
            width={windowWidth <= theme.screen.sm ? "65px" : "auto"}
          />

          <EventTag
            text={t.control.areaExit}
            color={eventChecker("사용지역이탈") ? "orange" : "grey"}
            withoutMl
            width={windowWidth <= theme.screen.sm ? "74px" : "auto"}
          />

          <EventTag
            text={t.control.dangerousAreaEntry}
            color={eventChecker("위험지역진입") ? "orange" : "grey"}
            withoutMl
            width={windowWidth <= theme.screen.sm ? "74px" : "auto"}
          />

          <EventTag
            text={t.control.batteryLow}
            color={eventChecker("배터리부족") ? "orange" : "grey"}
            withoutMl
            width={windowWidth <= theme.screen.sm ? "65px" : "auto"}
          />

          <EventTag
            text={t.control.engineAbandonment}
            color={eventChecker("시동방치") ? "orange" : "grey"}
            withoutMl
            width={windowWidth <= theme.screen.sm ? "65px" : "auto"}
          />
        </Chips>
      </StatusWrapper>
    </>
  );
};

const StatusWrapper = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 10px;
  margin-bottom: 10px;

  @media (max-width: ${sm}px) {
    flex-wrap: wrap;
    margin-bottom: 5px;
    gap: 5px;
    /* flex-direction: column; */
  }
`;

export const ThinText = styled.span`
  font-weight: 400;
  margin-right: 10px;
  font-size: 15px;
  line-height: 18px;
  color: ${theme.color.neutral_500};

  @media (max-width: ${sm}px) {
    font-size: 12px;
    margin-right: 5px;
  }
`;

const Chips = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 10px;
  @media (max-width: ${sm}px) {
    gap: 5px;
  }
`;
